<ng-container *ngIf="liveSide === 'home'; else liveTemplate">
  <div class="content">
    <div class="header-title-container">
      <div class="header-text">En İyi Canlı Etkinlikler</div>
    </div>

    <div class="header-story-container">
      <div *ngFor="let storyItem of listArray?.slice(0, 4)" class="story-item-header" [ngClass]="{ selected: storyItem.selected }" (click)="selectStoryItemForp1001(storyItem)">
        {{ storyItem.sportName }}
      </div>
    </div>
  </div>
</ng-container>
<ng-template #liveTemplate>
  <div class="story-slider-row story-slider-fixed">
    <div class="story-slider-box">
      <div class="story-slider-item filter">
        <ng-container [ngSwitch]="this._DataHelper.liveMatchFilter">
          <div *ngSwitchCase="'time'" class="time-filter-container" (click)="this.liveMatchFilterAction('league')">
            <image-loader-utils url="time-switch" extraClasses="time-filter-icon"></image-loader-utils>
            <div class="time-filter-text">{{ 'live.filter.time' | translate }}</div>
          </div>
          <div *ngSwitchCase="'league'" class="time-filter-container" (click)="this.liveMatchFilterAction('time')">
            <image-loader-utils url="time-switch" extraClasses="time-filter-icon"></image-loader-utils>
            <div class="time-filter-text">{{ 'live.filter.league' | translate }}</div>
          </div>
        </ng-container>
      </div>

      <div
        class="story-slider-item"
        *ngIf="isMobileView === true && ('isActiveBRSwipeWidget' | getEnv) === true"
        (click)="this._UiHelper.openBrSwipeWidget(this._LocalizationService.LANGCODE)">
        <image-loader-utils [url]="'swipe-icon1'" extraClasses="slidermenusvg swipeIcon"></image-loader-utils>
        <div class="story-slider-sport-name">Swipe</div>
      </div>
      <div class="story-slider-item" *ngIf="this._UserHelper.isSignedIn && this._DataHelper?.favList?.length > 0" routerLink="/favorites">
        <div class="story-slider-icon-count">
          <image-loader-utils url="star" extraClasses="story-slider-icon slidermenusvg favorited"></image-loader-utils>
          <div class="story-slider-count">
            {{ this._DataHelper.favList.length }}
          </div>
        </div>
        <div class="story-slider-sport-name">{{ 'Favorites' | translate }}</div>
      </div>
      <div
        class="story-slider-item"
        *ngIf="('isMySlipLive' | getEnv) && this._DataHelper?.mySlipMatchList?.length > 0"
        (click)="this.mySlipButtonAction(true)"
        [ngClass]="{ selected: this._DataHelper.isMySlipButton }">
        <div class="story-slider-icon-count">
          <image-loader-utils url="in-play" extraClasses="story-slider-icon slidermenusvg"></image-loader-utils>
          <div class="story-slider-count">
            {{ this._DataHelper?.mySlipMatchList?.length }}
          </div>
        </div>
        <div class="story-slider-sport-name live-animation">{{ 'my_slip_text' | translate }}</div>
      </div>
      <div
        class="story-slider-item"
        *ngIf="('isLiveStream' | getEnv) && this._LiveStreamService.liveTvList?.length > 0"
        (click)="this.onTvButtonAction(true)"
        [ngClass]="{ selected: this._LiveStreamService.isOnTvButton }">
        <div class="story-slider-icon-count">
          <image-loader-utils url="live" extraClasses="story-slider-icon slidermenusvg"></image-loader-utils>

          <div class="story-slider-count">
            {{ this._LiveStreamService.liveTvList?.length }}
          </div>
        </div>
        <div class="story-slider-sport-name live-animation">{{ 'On_Tv' | translate }}</div>
      </div>
      <div
        class="story-slider-item"
        *ngFor="let storyItem of listArray; let last = last"
        [ngClass]="{ selected: !(this._DataHelper.isMySlipButton || this._LiveStreamService.isOnTvButton) && storyItem.selected }"
        (click)="selectStoryItemForp1001(storyItem)">
        <div class="story-slider-icon-count">
          <ng-container
            *ngIf="
              this.sportsSvgList[storyItem.sportId]?.svgKey.trim(' ') !== 'tennis' &&
                this.sportsSvgList[storyItem.sportId]?.svgKey.trim(' ') !== 'icehockey' &&
                this.sportsSvgList[storyItem.sportId]?.svgKey.trim(' ') !== 'basketball';
              else elseTemplate
            ">
            <image-loader-utils [url]="this.sportsSvgList[storyItem.sportId]?.svgKey" extraClasses="story-slider-icon slidermenusvg"></image-loader-utils>
          </ng-container>
          <ng-template #elseTemplate>
            <image-loader-utils [url]="this.sportsSvgList[storyItem.sportId]?.svgKey" extraClasses="story-slider-icon slidermenupng" imageFormat="png"></image-loader-utils>
          </ng-template>

          <div class="story-slider-count" *ngIf="storyItem.count != null && storyItem.count != 0">
            {{ last ? totalCount : storyItem.count }}
          </div>
        </div>
        <div class="story-slider-sport-name" [ngClass]="{ 'force-inline-block': storyItem.sportName.length > 10 }">
          {{ storyItem.sportName }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
